export const MAPPA = 'MAPPA'